// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	const header = document.getElementById('js-header');
	const body = document.body;

	/*!
	 * CSS変数のIE対応
	*/
	cssVars({
		rootElement: document
	});

	/*!
	 * IE判定
	*/
	const userAgent = window.navigator.userAgent.toLowerCase();
	const isIE = () => {
		if (userAgent.indexOf(`msie`) != -1 || userAgent.indexOf(`trident`) != -1) {
			// console.log('browser is IE');
			return true;
		}
	}
	// if (isIE()) {
	// 	console.log('this browser is IE');
	// }

	/*!
	 * ブレークポイント
	*/
	const mediaQuery = window.matchMedia('(min-width: 960px)');
	let device = '';

	const checkMedia = (e) => {
		if (e.matches) {
			device = 'large';

			// ブレークポイント通過時のイベント作成
			const event = new CustomEvent('deviceLarge');
			window.dispatchEvent(event);
		} else {
			device = 'small';

			// ブレークポイント通過時のイベント作成
			const event = new CustomEvent('deviceSmall');
			window.dispatchEvent(event);
		}
	}

	checkMedia(mediaQuery);
	if (isIE()) {
		mediaQuery.addListener(checkMedia);
	} else {
		mediaQuery.addEventListener('change', checkMedia);
	}


	/*!
	 * ページ内リソース読み込み完了
	*/
	window.addEventListener('load', (e) => {
		document.body.classList.add('is-loaded');
	});


	/*!
	 * video 読み込み完了
	*/
	{
		if (document.getElementById('js-hero-video') != null) {
			const video = document.getElementById('js-hero-video');

			if (isIE()) {
				video.play();
				video.classList.add('is-video-play');
			} else {
				video
				.play()
				.then(() => {
					video.classList.add('is-video-play');
				})
				.catch((error) => {
					// console.log(error);
					const posterUrl = video.dataset.poster;
					video.setAttribute('poster',posterUrl);
					video.classList.add('is-video-play');
				});
			}
		}
	}


	/*!
	* モーダルopen時の背景固定処理
	*/

	let scrollY;

	const backfaceFix = () => {
		scrollY = window.pageYOffset;

		body.style.cssText = `
		position: fixed;
		width: 100vw;
		top: ${scrollY * -1}px;
		`;
		body.classList.add('is-fixed');
	}

	const backfaceRelease = () => {
		body.style.cssText = null;
		body.classList.remove('is-fixed');
		window.scrollTo(0, scrollY);
	}


	/*!
	 * ヘッダー追従処理
	*/
	{
		const className = 'is-header-hidden';
		const classNameBg = 'is-header-highlight';
		const offset = header.clientHeight;
		let startVal = 0;

		window.addEventListener('scroll', () => {
			const currentVal = window.pageYOffset;

			if (currentVal >= offset) {
				header.classList.add(classNameBg);
			} else {
				header.classList.remove(classNameBg);
			}

			if (currentVal > startVal) {
				if (currentVal >= offset) {
					header.classList.add(className);
				}
			} else if (currentVal < startVal) {
				header.classList.remove(className);
			}
			startVal = currentVal;
		});
	}


	/*!
	 * ヘッダーナビの開閉
	*/
	{
		const btn = document.querySelector('#js-mobile-menu');
		const className = 'is-hamburger-open';

		btn.addEventListener('click', (e) => {
			if (!body.classList.contains(className)) {
				body.classList.add(className);
				header.classList.remove('is-header-hidden');
				backfaceFix();
			} else {
				body.classList.remove(className);
				backfaceRelease();
			}
			e.preventDefault();
		});

		window.addEventListener('deviceLarge', () => {
			body.classList.remove(className);
			backfaceRelease();
		});

	}


	/*!
	 * ヘッダードロップダウンメニュー
	*/
	{
		const btns = document.querySelectorAll('.js-dropdown');
		const btnsArr = Array.prototype.slice.call(btns);
		let activeIndex = null;

		btnsArr.forEach((btn, index) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();

				const that = e.currentTarget;
				const submenu = that.nextElementSibling;
				const submenuHeight = submenu.firstElementChild.clientHeight;

				if (activeIndex !== null && activeIndex !== index) {
					if (device === 'large') {
						that.parentNode.classList.add('is-dropdown-active');
						submenu.style.height = submenuHeight + 'px';
						btnsArr[activeIndex].parentNode.classList.remove('is-dropdown-active');
						btnsArr[activeIndex].nextElementSibling.style.height = '0px';
						body.classList.add('is-header-menu-active');
					} else {
						if (that.parentNode.classList.contains('is-dropdown-active')) {
							that.parentNode.classList.remove('is-dropdown-active');
							that.nextElementSibling.style.height = '0px';
						} else {
							that.parentNode.classList.add('is-dropdown-active');
							submenu.style.height = submenuHeight + 'px';
						}
					}
				} else {
					if (that.parentNode.classList.contains('is-dropdown-active')) {
						that.parentNode.classList.remove('is-dropdown-active');
						that.nextElementSibling.style.height = '0px';
						body.classList.remove('is-header-menu-active');
					} else {
						that.parentNode.classList.add('is-dropdown-active');
						submenu.style.height = submenuHeight + 'px';
						body.classList.add('is-header-menu-active');
					}
				}

				activeIndex = index;

			})

			if (device === 'large') {
				const offset = header.clientHeight;

				window.addEventListener('scroll', () => {
					const currentVal = window.pageYOffset;
					if (currentVal >= offset) {
						btnsArr.forEach((btn, index) => {
							btn.parentNode.classList.remove('is-dropdown-active');
							btn.nextElementSibling.style.height = '0px';
							body.classList.remove('is-header-menu-active');
						});
					}
				});
			}

			window.addEventListener('deviceLarge', () => {
				btnsArr.forEach((btn, index) => {
					btn.parentNode.classList.remove('is-dropdown-active');
					btn.nextElementSibling.style.height = '0px';
				});
			});
		});
	}

	/*!
	 * スムーススクロール
	*/
	{
		const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
		// const headerHeight = header.clientHeight;
		const headerHeight = 0;

		for (let i = 0; i < smoothScrollTrigger.length; i++){
			smoothScrollTrigger[i].addEventListener('click', (e) => {
				e.preventDefault();
				let href = smoothScrollTrigger[i].getAttribute('href');
				let targetElement = document.getElementById(href.replace('#', ''));
				const rect = targetElement.getBoundingClientRect().top;
				const offset = window.pageYOffset;
				const gap = headerHeight;
				const target = rect + offset - gap;
				window.scrollTo({
					top: target,
					behavior: 'smooth',
				});
			});
		}
	}

	/*!
	 * スティッキーボタン
	*/
	let scrollTop = window.pageYOffset;
	const floating = document.getElementById('js-sticky-button');
	let floatingTriggerPos = 100;

	if ( floating ) {
		if ( scrollTop >= floatingTriggerPos ) {
			floating.classList.add('is-visible');
		} else {
			floating.classList.remove('is-visible');
		}

		window.addEventListener('scroll', function(e) {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop
			let currentPos = scrollTop

			if ( floating ) {

				if ( scrollTop >= floatingTriggerPos ) {
					floating.classList.add('is-visible');
				} else {
					floating.classList.remove('is-visible');
				}
			}
		})

	}


	/*!
	 * Swiper
	*/

	// トップページ > News
	const sliderNews = () => {
		if (!document.querySelectorAll('.js-home-news')[0]) {
			return false;
		}

		// swiperオプション
		let swiperOption = {
			loop: true,
			loopAdditionalSlides: 1,
			speed: 2000,
			slidesPerView: 1,
			allowTouchMove: false,
			spaceBetween: 40,

			autoplay: {
				delay: 4000,
			},

			// navigation: {
			// 	prevEl: '.js-xxx-prev',
			// 	nextEl: '.js-xxx-next',
			// },

			// pagination: {
			// 	el: '.js-xxx-pagination',
			// 	type: 'bullets',
			// 	bulletClass: 'xxxxx',
			// 	bulletActiveClass: 'xxxxx--active',
			// 	clickable: false,
			// },

			// on: {
			//   init: ()=> {
			//     console.log('init.....');
			//   }
			// },

			// breakpoints: {
			// 	768: {
			// 		allowTouchMove: false,
			// 	}
			// }
		}

		// swiper実行
		const mainSwiper = new Swiper('.js-home-news', swiperOption);

	}

	sliderNews();

	// 関連記事スライダー
	const sliderPosts = () => {
		if (!document.querySelectorAll('.js-posts-carousel')[0]) {
			return false;
		}

		const sliderElm = document.querySelector('.js-posts-carousel');
		const slides = 3;
		let loopable = true;

		if (sliderElm.querySelectorAll('.swiper-slide').length <= slides) {
			sliderElm.classList.add('is-slider-disabled');
			loopable = false;
		}

		// swiperオプション
		let swiperOption = {
			loop: loopable,
			loopAdditionalSlides: 1,
			speed: 1000,
			slidesPerView: slides,
			// allowTouchMove: false,
			spaceBetween: 40,

			// autoplay: {
			// 	delay: 4000,
			// },

			navigation: {
				prevEl: '.js-posts-carousel-prev',
				nextEl: '.js-posts-carousel-next',
			},

			// pagination: {
			// 	el: '.js-xxx-pagination',
			// 	type: 'bullets',
			// 	bulletClass: 'xxxxx',
			// 	bulletActiveClass: 'xxxxx--active',
			// 	clickable: false,
			// },

			// on: {
			//   init: ()=> {
			//     console.log('init.....');
			//   }
			// },

			// breakpoints: {
			// 	768: {
			// 		allowTouchMove: false,
			// 	}
			// }
		}

		// swiper実行
		const mainSwiper = new Swiper('.js-posts-carousel', swiperOption);

		window.addEventListener('deviceSmall', () => {
			mainSwiper.destroy(false,true);
		});

	}

	if (device === 'large') {
		sliderPosts();
	}

	window.addEventListener('deviceLarge', () => {
		sliderPosts();
	});


	// 等速スライダー
	const sliderInfinite = () => {
		if (!document.querySelectorAll('.js-infinite-carousel')[0]) {
			return false;
		}

		const sliderElm = document.querySelectorAll('.js-infinite-carousel');

		sliderElm.forEach((elm, index) => {
			const slidesLength = elm.querySelectorAll('.swiper-slide').length;
			const threshold = 4;
			let reversible = false;

			if (elm.querySelectorAll('.swiper-slide').length <= threshold) {
				elm.classList.add('is-slider-disabled');
				return false;
			}

			if ( elm.dataset.directionReverse == 1 ) {
				reversible = true;
			}

			// swiperオプション
			let swiperOption = {
				loop: true,
				loopedSlides: slidesLength,
				speed: 10000,
				slidesPerView: 'auto',
				allowTouchMove: false,
				// spaceBetween: 40,

				autoplay: {
					delay: 0,
					reverseDirection: reversible,
				},

			}

			// swiper実行
			const mainSwiper = new Swiper(elm, swiperOption);
		})

	}

	sliderInfinite();


	/*!
	 * Entry Form Variable
	*/
	const form = document.querySelector( '.snow-monkey-form' );

	/*!
	 * Entry Form Validation
	*/
	if ( form ) {

		// ファイル拡張子のチェック
		let uploadFile = document.querySelectorAll('.smf-file-control input[type=file]');

		for ( let i = 0; i < uploadFile.length; i++) {
			uploadFile[i].addEventListener('change', function (e) {
				var files = e.target.files;
				console.log(files);
				for (var j = 0, file; (file = files[j]); j++) {
					if ( file.type.match('application/pdf') ) {
						continue;
					} else {
						alert('添付ファイルはPDF形式でご登録してください');
						break;
					}
				}
			});
		}

		// エラー時のバリデーション
		form.addEventListener( 'smf.invalid', ( event ) => {
			let vldtnItem = document.querySelectorAll('.wp-block-snow-monkey-forms-item.smf-item');
			let vldtnTrgt = document.querySelectorAll('.smf-error-messages');

			for ( let i = 0; i < vldtnItem.length; i++) {
				vldtnItem[i].classList.remove('has-error');
			}
			for ( let i = 0; i < vldtnTrgt.length; i++) {
				let parent = vldtnTrgt[i].closest('.wp-block-snow-monkey-forms-item.smf-item');
				parent.classList.add('has-error');
			}

		} );

		form.addEventListener( 'smf.confirm', ( event ) => {
			let vldtnItem = document.querySelectorAll('.wp-block-snow-monkey-forms-item.smf-item');

			for ( let i = 0; i < vldtnItem.length; i++) {
				vldtnItem[i].classList.remove('has-error');
			}
		} );
	}


	/*!
	 * Entry Form Submit
	*/
	if ( form ) {
		form.addEventListener( 'smf.complete', ( event ) => {
			//console.log();
			gtag('event', 'form_submit', {
				'event_category': 'form',
				'event_label': 'submit',
			});
		} );
	}


} );

